import { createFileRoute } from '@tanstack/react-router';
import { ArticlePage } from '@/pages/member-portal/articles/ArticlePage';

function MemberPortalAboutRoute() {
	return <ArticlePage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/about')({
	component: MemberPortalAboutRoute,
});
